import { AlertType, RepeatAlarm, } from "@reducers/access-points/models/access-point-dto";
const validRepeat = new Set([
    RepeatAlarm.AlarmRepeatUntilResolved,
    RepeatAlarm.AlaramRepeats3Times,
    RepeatAlarm.NoRepeat,
]);
const validAlert = new Set([
    AlertType.EmailAndSMS,
    AlertType.EmailOnly,
    AlertType.SMSOnly,
]);
/** Map API / legacy 0 or invalid values to a select field value (never "0"). */
export function repeatAlarmToSelectValue(v) {
    if (v == null || v === 0 || !validRepeat.has(v)) {
        return String(RepeatAlarm.NoRepeat);
    }
    return String(v);
}
export function alertTypeToSelectValue(v) {
    if (v == null || v === 0 || !validAlert.has(v)) {
        return String(AlertType.EmailAndSMS);
    }
    return String(v);
}
export function parseRepeatAlarmOrDefault(raw) {
    const n = raw != null && raw !== "" ? parseInt(raw, 10) : NaN;
    if (!Number.isFinite(n) || n === 0 || !validRepeat.has(n)) {
        return RepeatAlarm.NoRepeat;
    }
    return n;
}
export function parseAlertTypeOrDefault(raw) {
    const n = raw != null && raw !== "" ? parseInt(raw, 10) : NaN;
    if (!Number.isFinite(n) || n === 0 || !validAlert.has(n)) {
        return AlertType.EmailAndSMS;
    }
    return n;
}
